import React, { Component } from "react";
import { Modal, ModalBody } from "reactstrap";
import {
  IMAGE_THUMB_URL,
  IMAGE_FULL_URL,
  CLOUDFRONT_URL,
} from "../../../config/config";
import PreviewImage from "../../../views/PreviewImage/";
import * as moment from "moment";
import "moment/locale/th";

class CarDocList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      preview_image_url: "",
      preview_image_select: false,
    };
    this.togglePreviewImage = this.togglePreviewImage.bind(this);
  }

  onCarDocDelete(car_doc) {
    this.props.onDelete(car_doc);
  }

  onPreviewSelected(url) {
    this.setState({
      preview_image_url: url,
      preview_image_select: true,
    });
  }
  togglePreviewImage() {
    this.setState({
      preview_image_select: !this.state.preview_image_select,
    });
  }

  render() {
    let car_doc_list = this.props.car_doc.map((car_doc, index) => {
      let car_doc_url = "";

      if (car_doc.car_doc_file.includes("https")) {
        // car_doc_url = car_doc.car_doc_file
        car_doc_url = CLOUDFRONT_URL + car_doc.car_doc_key;
      } else {
        car_doc_url = IMAGE_FULL_URL + car_doc.car_doc_file;
      }

      let docType = car_doc_url.indexOf(".pdf") !== -1 ? "pdf" : "image";

      return (
        <tr key={index}>
          <td className="text-center">{index + 1}</td>
          <td className="text-center">
            {docType === "pdf" ? (
              <a href={car_doc_url} target="_blank" rel="noopener noreferrer">
                <i className="fa fa-file-pdf-o"></i> เอกสารรถ
              </a>
            ) : (
              <img
                src={car_doc_url}
                style={{ cursor: "pointer", width: "120px", height: "auto" }}
                onClick={() => this.onPreviewSelected(car_doc_url)}
                alt="เอกสาร"
              />
            )}

            {/*<img
              src={IMAGE_FULL_URL + car_doc.car_doc_file}
              className="img-cars"
              maxWidth={160}
              style={{'cursor':'pointer'}}
              onClick={()=>this.onPreviewSelected(IMAGE_FULL_URL + car_doc.car_doc_file)}
              alt="เอกสาร"
            />*/}
          </td>
          <td className="text-center">{car_doc.car_doc_name}</td>
          <td className="text-center">
            {car_doc.fullname}
            <br />
            {moment(car_doc.updated_at).locale("th").format("DD-MM-YYYY HH:mm")}
          </td>
          <td className="text-center">
            <button
              className="btn btn-sm btn-danger btn-md-width"
              onClick={() => this.onCarDocDelete(car_doc)}
            >
              <i className="fa fa-remove"></i> ลบ
            </button>
          </td>
        </tr>
      );
    });

    return (
      <div>
        <table
          className={
            this.props.car_doc.length > 0
              ? "table table-striped "
              : "table table-striped hidden"
          }
        >
          <thead>
            <tr>
              <th className="text-center">#</th>
              <th className="text-center">ไฟล์เอกสาร</th>
              <th className="text-center">ชื่อเอกสาร</th>
              <th className="text-center">ผู้ทำรายการ</th>
              <th className="text-center"></th>
            </tr>
          </thead>
          <tbody>{car_doc_list}</tbody>
        </table>

        <div
          className={
            this.props.car_doc.length === 0 ? " text-center  " : "hidden"
          }
        >
          <strong className="text-danger">ไม่พบรายการเอกสารรถ</strong>
        </div>

        <Modal
          isOpen={this.state.preview_image_select}
          toggle={this.togglePreviewImage}
          className={"modal-lg "}
        >
          <ModalBody>
            <PreviewImage imageUrl={this.state.preview_image_url} />
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default CarDocList;
